import { useState } from 'react';
import { C } from '../../constants/colors.js';
import { F, N } from '../../constants/fonts.js';
import { Btn } from '../ui/Btn.jsx';
import { supaUpdatePassword } from '../../lib/supabase.js';

export function PasswordRecoveryScreen({onDone}){
  const[pw,setPw]=useState('');const[confirm,setConfirm]=useState('');const[err,setErr]=useState('');const[busy,setBusy]=useState(false);const[done,setDone]=useState(false);
  const doUpdate=async()=>{
    if(pw.length<8){setErr('Password must be at least 8 characters.');return;}
    if(pw!==confirm){setErr('Passwords do not match.');return;}
    setBusy(true);setErr('');
    const{error}=await supaUpdatePassword(pw);
    setBusy(false);
    if(error){setErr(error.message);return;}
    setDone(true);
    setTimeout(()=>onDone(),2000);
  };
  return <div style={{padding:'32px 24px',textAlign:'center'}}>
    <div style={{fontSize:48,marginBottom:12}}>{"🔑"}</div>
    <div style={{fontFamily:F,fontSize:22,fontWeight:700,color:C.text,marginBottom:8}}>Set New Password</div>
    {done?<div style={{fontFamily:N,fontSize:15,color:C.success,padding:'16px',background:C.successLight,borderRadius:14}}>Password updated! Redirecting...</div>
    :<>
      {err&&<div style={{fontFamily:N,fontSize:13,color:C.danger,marginBottom:12,padding:'8px 12px',background:C.dangerLight,borderRadius:10}}>{err}</div>}
      <input type="password" placeholder="New password (8+ characters)" value={pw} onChange={e=>setPw(e.target.value)} style={{width:'100%',padding:'14px 16px',borderRadius:14,border:'2px solid #E5E7EB',fontFamily:N,fontSize:15,marginBottom:12,outline:'none'}}/>
      <input type="password" placeholder="Confirm new password" value={confirm} onChange={e=>setConfirm(e.target.value)} onKeyDown={e=>{if(e.key==='Enter')doUpdate();}} style={{width:'100%',padding:'14px 16px',borderRadius:14,border:'2px solid #E5E7EB',fontFamily:N,fontSize:15,marginBottom:16,outline:'none'}}/>
      <Btn onClick={doUpdate} disabled={busy} full>{busy?'Updating...':'Update Password'}</Btn>
    </>}
  </div>;
}

// ── AUTH SECTION (for ParentSettings) ───────────────────
